<template v-slot="extension">
  <div>
    <vonap-window
      transition="dialog-scale-transition"
      title="Dashboard confirmation"
      width="400px"
      height="550px"
      :modal="true"
      @success="closeAndRefresh"
      @close="close"
      :visible="showSendForm"
    >
      <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="formSubmit">
        <v-container fluid grid-list-sm class="pa-0">
          <v-layout row justify-center>
            <v-card class="mx-auto">
              <v-card-title>
                <span class="title font-weight-bold"
                  >Create {{ dashboardCount }} Dashboards on</span
                >
              </v-card-title>
              <v-card-text grid-list-xl>
                <v-layout row wrap>
                  <v-flex xs12>
                    <kendo-datepicker
                      v-model="reportDate"
                      :format="'yyyy-MM-dd'"
                      style="width: 125px;display:inline-block;"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="Scenario"
                      required
                      v-model="currentScenario.scenarioName"
                      :rules="[v => !!v || 'Scenario name is required']"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="To"
                      placeholder="Email address"
                      v-model="currentScenario.sendToEmail"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="Subject"
                      placeholder="Subject"
                      v-model="currentScenario.subject"
                    />
                  </v-flex>
                  <v-flex xs12>
                    <vonap-form-label label="Body">
                      <textarea
                        name="body"
                        style="width:98%;"
                        rows="6"
                        v-model="currentScenario.body"
                      ></textarea>
                    </vonap-form-label>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-container>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-btn block color="success" @click="formSubmit">Yes</v-btn>
                    </v-flex>
                    <v-flex xs6>
                      <v-btn block color="error" @click="closeAndRefresh">No</v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-layout>
        </v-container>
      </v-form>
    </vonap-window>

    <v-layout row wrap class="dashboardList">
      <v-flex md12>
        <page-toolbar>
          <kendo-datepicker
            v-model="reportDate"
            :format="'yyyy-MM-dd'"
            style="width: 125px;display:inline-block;"
          />
          <kendo-dropdownlist
            v-model="responsible"
            :dataSource="responsibleDataSource"
            @change="refreshGrid"
            style="width: 300px"
          />
          <v-btn color="warning" small fab flat @click="openForm" title="Create Dashboard">
            <v-icon>fas fa-bolt </v-icon>
          </v-btn>
        </page-toolbar>
        <kendo-grid
          :filterable="true"
          :sortable="true"
          :persistSelection="true"
          :data-source="dataSource"
          :pageable="pageableSettings"
          ref="dashboardGrid"
        >
          <kendo-grid-column :selectable="true" :width="50"> </kendo-grid-column>
          <kendo-grid-column field="dashboardName" title="Dashboard" :width="450" />
          <kendo-grid-column field="responsible" title="Responsible" />
        </kendo-grid>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import {mapGetters} from 'vuex'
import VonapFormLabel from '@/components/VonapFormLabel'
import PageToolbar from '@/components/PageToolbar'
import notification from '@/helpers/notification'
import VonapWindow from '@/components/VonapWindow'

export default {
  name: 'DashboardsCreateScenario',
  mounted() {},
  data() {
    return {
      showSendForm: false,
      valid: false,
      selectedDashboardsId: [],
      pageableSettings: {
        alwaysVisible: false,
      },
      responsible: 'ALL',
      reportDate: kendo.toString(new Date(), 'yyyy-MM-dd'),
      saving: false,
      currentScenario: {},
    }
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    responsibleDataSource() {
      return new kendo.data.DataSource({
        transport: {
          read: {
            type: 'GET',
            url: '/api/config/dashboardScenario/getResponsibleList',
            dataType: 'json',
          },
        },
      })
    },
    dataSource() {
      return new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        serverPaging: false,
        serverFiltering: true,
        serverSorting: true,
        transport: {
          read: {
            type: 'GET',
            url: '/api/config/dashboardScenario/getDashboadDataSource',
            data: {
              responsible: this.responsible,
            },
            dataType: 'json',
          },
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'dashboardId',
            fields: {
              dashboardId: {type: 'number'},
              dashboardName: {type: 'string'},
              responsible: {type: 'string'},
            },
          },
        },
        error: function() {
          //let grid = $('#contractGrid').data('kendoGrid')
          //grid.one('dataBinding', e => {
          //  e.preventDefault()
          //})
        },
      })
    },

    getSelectedScenarioId() {
      if (!this.querySelectedScenario) {
        return this.selectedScenario
      }
      return +this.querySelectedScenario
    },
    getIncomigScenarioId() {
      if (!this.querySelectedScenario) {
        return null
      }
      return +this.querySelectedScenario
    },
    dashboardCount() {
      return this.selectedDashboardsId.length
    },
  },
  methods: {
    async formSubmit() {
      if (!this.$refs.form.validate()) return
      this.saving = true
      this.currentScenario.dashBoardList = this.selectedDashboardsId
      this.currentScenario.dashboardDate = this.reportDate
      await axios
        .post('/api/config/dashboardScenario', {
          item: this.currentScenario,
          clientId: +this.clientId,
        })
        .catch(() => (this.errored = true))
      this.isNew = false
      notification('Dashboard created', 'success')
      this.currentScenario = {}
      this.saving = false
      this.closeAndRefresh()
      this.$emit('created')
    },
    async getData() {
      const {data: currentScenario} = await axios.get('/api/config/dashboardScenario/getScenario', {
        params: {dashboardScenarioId: -1, clientId: this.clientId},
      })
      this.currentScenario = currentScenario
    },

    openForm() {
      const grid = this.$refs.dashboardGrid.kendoWidget()
      const selectedIds = grid.selectedKeyNames().map(id => +id)
      if (selectedIds.length == 0) {
        notification('Please select at least one', 'error')
      } else {
        this.selectedDashboardsId = selectedIds
        this.getData()
        this.showSendForm = true
      }
    },
    close() {
      this.showSendForm = false
    },
    closeAndRefresh() {
      this.showSendForm = false
      this.responsible = ''
      Vue.nextTick(() => {
        this.refreshGrid()
      })
    },
    refreshGrid() {
      this.selectedDashboardsId = []
      this.responsible = 'ALL'
      this.dataSource.read()
    },
  },
  components: {
    PageToolbar,
    VonapFormLabel,
    VonapWindow,
  },
}
</script>
<style scoped>
textarea {
  display: flex;
  vertical-align: bottom;
  border: 1px;
  border-style: dotted;
}
</style>
